import React, { useEffect } from 'react'
import ContactUs from './ContactUs'
import Navbar from '../NavBar/Navbar'
import Home9 from '../Home/Home9'

const ContactUsMain = () => {
  useEffect(() => {
    // Ensures page is scrolled to the top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <ContactUs />
      <Home9 />
    </div>
  )
}

export default ContactUsMain
